// extracted by mini-css-extract-plugin
export default {"form":"style_form__jKjgD","input":"style_input__Z9Rt4","button":"style_button__Z+K5L"};